import { clampDate, dayStart, dayEnd } from "../../../Helpers/Utils";
import React, { useState } from "react";
import { setBooking, setPickup, setStep } from "../../../Reducer/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import NextPrev from "../../../Helpers/Components/NextPrev";
import Handler from "../../../Helpers/Components/Handler"
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

const Trip = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const setSteps = () => {
        dispatch(setStep(0))
    }
    const handleNext = async () => {
        if (!booking?.km?.end || Number(booking?.km?.end) < 0) {
            toast.error("Invalid End KM");
        } else if (Number(booking?.km?.end) <= Number(booking?.km?.start)) {
            toast.error("End KM must be greater than Start KM")
        } else if (!booking?.fuel?.end || Number(booking?.fuel?.end) < 0 || Number(booking?.fuel?.end) > 100) {
            toast.error("Invalid End Fuel");
        } else {
            setLoading(true);
            let data = {
                km: { end: Number(booking?.km?.end || 0), ...(booking?.km?.start ? { start: Number(booking?.km?.start || 0) } : {}) },
                fuel: { end: Number(booking?.fuel?.end || 0), ...(booking?.fuel?.start ? { start: Number(booking?.fuel?.start || 0) } : {}) },
                fastTag: { end: Number(booking?.fastTag?.end || 0), ...(booking?.fastTag?.start ? { start: Number(booking?.fastTag?.start || 0) } : {}) },
                pickup: new Date(booking?.pickupDetails?.pickup)
            }
            const response = await Handler({ method: 'patch', url: `/booking/pending/first/update/${props?.bookingId}`, data })
            setLoading(false)
            if (response?.success) {
                dispatch(setStep(2))
            } else {
                toast.error(response?.message)
            }
        }
    }
    return (
        <React.Fragment>
            <div className="row mt-3">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="ddate" className="form-label"> Delivery Date & Time </label>
                        <input readOnly name="ddate" id="ddate" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.delivery ? moment(new Date(booking?.deliveryDetails?.delivery))?.format("DD/MM/YYYY hh:mm A") : ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pdate" className="form-label"> Pickup Date & Time </label>
                        {/* <input readOnly name="pdate" id="pdate" autoComplete="off" onChange={(e) => { dispatch(setPickup({ pickup: new Date(e) })) }} className="form-control input-theme text-uppercase" value={booking?.pickupDetails?.pickup ? moment(new Date(booking?.pickupDetails?.pickup))?.format("DD/MM/YYYY hh:mm A") : ""} /> */}
                        <div className=" datepicker-top">
                        <DatePicker
                            className="input-theme"
                            value={booking?.pickupDetails?.pickup ? new Date(booking?.pickupDetails?.pickup) : new Date(new Date(booking?.deliveryDetails?.delivery)?.setDate(new Date(booking?.deliveryDetails?.delivery)?.getDate() + 1))}
                            onChange={(e) => {
                                const date = new Date(e);
                                const minutes = date.getMinutes();
                                const roundedMinutes = Math.ceil(minutes / 5) * 5;
                                date.setMinutes(roundedMinutes);
                                date.setSeconds(0);
                                date.setMilliseconds(0);
                                dispatch(setPickup({ pickup: clampDate(date, booking?.deliveryDetails?.delivery ? new Date(booking?.deliveryDetails?.delivery) : new Date(), new Date(new Date().setMinutes(new Date().getMinutes() + 5)))?.toString() }))
                            }}
                            format="DD-MM-YYYY hh:mm A"
                            plugins={[
                                <TimePicker position="bottom" hideSeconds mStep={5} />
                            ]}
                            minDate={dayStart(booking?.deliveryDetails?.delivery ? new Date(booking?.deliveryDetails?.delivery) : new Date())}
                            maxDate={dayEnd(new Date(new Date().setMinutes(new Date().getMinutes() + 5)))}
                            disabled={loading || !booking?.deliveryDetails?.delivery}
                        />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="location" className="form-label"> Delivery Location </label>
                        <input readOnly name="location" id="location" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.location || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pickupLocation" className="form-label"> Pickup Location </label>
                        <input readOnly name="pickupLocation" id="pickupLocation" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.pickupDetails?.location || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="package" className="form-label"> Package </label>
                        <input name="package" id="package" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.package || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="segment" className="form-label"> Type of Car </label>
                        <input name="segment" id="segment" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.car?.segment || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startKm" className="form-label"> Start KM </label>
                        <input name="startKm" id="startKm" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.km?.start || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="endKm" className="form-label"> End KM </label>
                        <input name="endKm" id="endKm" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ km: { ...(booking?.km?.start ? { start: booking?.km?.start } : {}), end: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.km?.end || ""} />
                    </div>
                </div>
                {
                    booking?.km?.end ?
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="usedKm" className="form-label"> Used KM </label>
                                <input name="usedKm" id="usedKm" autoComplete="off" readOnly disabled className="form-control input-theme text-uppercase" value={(Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) > 0 ? (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) : 0} />
                            </div>
                        </div> : ""
                }

            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startFuel" className="form-label"> Start Fuel </label>
                        <input name="startFuel" id="startFuel" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.fuel?.start ?? 0} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="endFuel" className="form-label"> End Fuel </label>
                        <input name="endFuel" id="endFuel" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ fuel: { ...(booking?.fuel?.start ? { start: booking?.fuel?.start } : {}), end: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.fuel?.end ?? 0} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="usedFuel" className="form-label"> Used Fuel </label>
                        <input name="usedFuel" id="usedFuel" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(Number(booking?.fuel?.start || 0) - Number(booking?.fuel?.end || 0)) > 0 ? (Number(booking?.fuel?.start || 0) - Number(booking?.fuel?.end || 0)) : 0} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startFastTag" className="form-label"> Start FasTag </label>
                        <input name="startFastTag" id="startFastTag" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.fastTag?.start ?? 0} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="endFastTag" className="form-label"> End FasTag </label>
                        <input name="endFastTag" id="endFastTag" onChange={(e) => { if (/^-?\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ fastTag: { ...(booking?.fastTag?.start ? { start: booking?.fastTag?.start } : {}), end: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.fastTag?.end ?? 0} />
                    </div>
                </div>
                {booking?.fastTag?.end &&
                    (Number(booking?.fastTag?.start) - Number(booking?.fastTag?.end)) >= 0 ?
                    <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="usedFastTag" className="form-label"> Used FasTag </label>
                            <input name="usedFastTag" readOnly id="usedFastTag" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0))} />
                        </div>
                    </div>
                    :
                    <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="usedFastTag" className="form-label"> Refund Fastag </label>
                            <input name="usedFastTag" readOnly id="usedFastTag" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(Number(booking?.fastTag?.end || 0) - Number(booking?.fastTag?.start || 0))} />
                        </div>
                    </div>

                }

            </div>
            <NextPrev step={1} setStep={setSteps} last={3} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Trip;